import type { ReactNode } from "react";
import NewBadge from "@/components/NewBadge";

type HeroLaunchBadgesProps = {
  verifiedBadge?: ReactNode;
  showNewBadge: boolean;
  className?: string;
};

const HeroLaunchBadges = ({
  verifiedBadge,
  showNewBadge,
  className = "flex flex-row gap-2 w-fill md:w-auto justify-start",
}: HeroLaunchBadgesProps) => {
  if (!verifiedBadge && !showNewBadge) return null;

  return (
    <div className={className}>
      {showNewBadge ? <NewBadge /> : null}
      {verifiedBadge}
    </div>
  );
};

export default HeroLaunchBadges;
